<template>
  <div class="pics">
    <div class="list animate__animated" :class="{'animate__pulse':item.isHover}" @mouseover="mouseover(index)" @mouseleave="mouseleave"  v-for="(item,index) in list" :key="index">
      <img :src="item.img" alt="">
      <div class="text-wrap">
        <div class="tit">{{item.title}}</div>
        <div class="des">{{item.info}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  data(){
    return{
      list:[
        {
          title:'信用穿透',
          info:'核心企业开立的数字资产凭证，可在供应链内无限拆分，无限流转实现核心企业的信用多层穿透，解决上游供应商的融资及付款问题',
          img:require('../../../assets/img/index/pics-1.png'),
          isHover:false
        },
        {
          title:'双链概念',
          info:'区块链+供应链融合机制',
          img:require('../../../assets/img/index/pics-2.png'),
          isHover:false
        },
        {
          title:'融资渠道多样化',
          info:'建立多元化、多层次的融资渠道',
          img:require('../../../assets/img/index/pics-3.png'),
          isHover:false
        }
      ]
    }
  },
  methods: {
    mouseleave(){
      this.list.forEach((item)=>{
        item.isHover = false;
      });
    },
    mouseover(index){
      this.list.forEach((item)=>{
        item.isHover = false;
      });
      this.list[index].isHover = true;
    }
  },
}
</script>

<style lang="less" scoped>
.pics{
  width:100vw;
  height:449px;
  background: #fff;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  .list{
    display: flex;
    width:378px;
    height:100%;
    position: relative;
    overflow:hidden;
    img{
      position: absolute;
      left:0;
      top:0;
    }
    .text-wrap{
      width:100%;
      position: relative;
      padding-top:170px;
      .tit{
        font-family: PingFang HK;
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 28px;
        color: #FFFFFF;
        margin-bottom:16px;
        text-align:center;
      }
      .des{
        font-family: PingFang HK;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        color: #FFFFFF;
        text-align: center;
        max-width: 250px;
        margin: 0 auto;
      }
    }
  }
}
</style>